// extracted by mini-css-extract-plugin
export default {"root":"FullWidthToggle_root__x-Gv1"};